import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';
import { resetVersionDetails } from '../../../../../slices/campaigns/reducer';
import { toggleAddCreativeModal } from '../../../../../slices/modals/reducer';

function NewImageBtn() {
  const dispatch = useDispatch();

  const selectMenuPath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectMenuPath);

  async function showAddCreative() {
    dispatch(resetVersionDetails());
    dispatch(toggleAddCreativeModal())
  }
  
  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignEdit")) {
    return (
      <button className='btn btn-success' onClick={showAddCreative}>
        <i className='ri-add-fill align-middle me-2'></i>
        Add New
      </button>
    )
  } else {
    return null;
  }

}

export default NewImageBtn
